import { InspectionTemplate } from "@stormwater-software/lib-inspection-templates";
import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { Modal } from "@stormwater-software/lib-ui";
import inspectionTemplateApi from "../../utils/api/inspectionTemplate";
import { AppDivisionContext } from "../../contexts/AppDivisionContext";

export interface IInspectionTemplateArchiveProps {
  inspectionTemplate: InspectionTemplate;
}

const InspectionTemplateArchive: React.FC<IInspectionTemplateArchiveProps> = ({
  inspectionTemplate,
}) => {
  const [show, setShow] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [redirect, setRedirect] = useState(false);
  const { appDivisionId } = useContext(AppDivisionContext);

  const isArchived = !!(inspectionTemplate as any).archivedAt;
  const actionLabel = isArchived ? "Unarchive" : "Archive";

  const handleSubmit = () => {
    setErrorMsg("");

    const request = isArchived
      ? inspectionTemplateApi.unarchive(inspectionTemplate.id)
      : inspectionTemplateApi.archive(inspectionTemplate.id);

    request
      .then(() => {
        setShow(false);
        setRedirect(true);
      })
      .catch(e => {
        if (e.message) {
          setErrorMsg(e.message);
        } else if (e.response && e.response.data && e.response.data.message) {
          setErrorMsg(e.response.data.message);
        } else {
          setErrorMsg("An error has occurred");
        }
      });
  };

  if (redirect) {
    return (
      <Redirect to={`/divisions/${appDivisionId}/inspection-templates`} />
    );
  }

  return (
    <React.Fragment>
      <button
        className="outline"
        onClick={() => {
          setShow(true);
          setErrorMsg("");
        }}
      >
        {actionLabel}
      </button>
      <Modal
        show={show}
        handleClose={() => setShow(false)}
        handleSubmit={handleSubmit}
        errorMsg={errorMsg}
        title={`${actionLabel} Inspection Template`}
        hideButtons={true}
        classes="delete-modal-custom-buttons"
      >
        {isArchived ? (
          <p>
            Restore the <strong>{inspectionTemplate.name}</strong> inspection
            template? It will become available again in the create-project and
            modify-inspection form pickers.
          </p>
        ) : (
          <p>
            Archive the <strong>{inspectionTemplate.name}</strong> inspection
            template? It will be hidden from the create-project and modify-
            inspection form pickers. You can restore it any time from the
            Archived view.
          </p>
        )}
        <div className="buttons">
          <button
            className="reversed outline"
            type="button"
            onClick={() => setShow(false)}
          >
            Cancel
          </button>
          &nbsp;
          <button className="primary reversed" onClick={handleSubmit}>
            {actionLabel}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default InspectionTemplateArchive;
